import { EventrDate } from '@eventr/common'
import {
    ColoursObj,
    Gutters,
    MenuButton,
    Typography,
} from '@eventr/common-storybook'
import { Radio, Stack } from '@mui/material'
import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { bs } from '../../../state/bound.store'
import { useLanguageContext } from '../../../state/languageState/languageContext'
import { useGlobalRouter } from '../../globalRouter/useGlobalRouter'
import { NavigationView } from '../../layout/NavigationView'

export const TimePage: FC = () => {
    const { timeFormat, setTimeFormat } = useLanguageContext(
        useShallow((s) => ({
            timeFormat: s.timeFormat,
            setTimeFormat: s.setTimeFormat,
        }))
    )
    const { goBack } = useGlobalRouter()

    return (
        <NavigationView
            navigationBarTitle={i18n.t('account.time')}
            backButtonAction={() => {
                goBack()
            }}
            usePageTransition
        >
            <Gutters>
                <Stack gap={'16px'}>
                    <MenuButton
                        onClick={() => {
                            setTimeFormat('HH:mm')
                            bs().setCurrentItin(bs().selectedItinID)
                        }}
                        style={{
                            background: ColoursObj.backgrounds.secondary,
                        }}
                    >
                        <Stack direction={'row'} gap={'16px'}>
                            <Radio
                                style={{ padding: '0px' }}
                                sx={{
                                    color: ColoursObj.font.primary,
                                }}
                                checked={timeFormat === 'HH:mm'}
                            />
                            <Typography>
                                {new EventrDate(
                                    '04:20'
                                ).userLocalLuxon.toFormat('HH:mm') +
                                    ' ' +
                                    new EventrDate(
                                        '16:20'
                                    ).userLocalLuxon.toFormat('HH:mm') +
                                    ' ( 24 ' +
                                    i18n.t('general.hour') +
                                    ' )'}
                            </Typography>
                        </Stack>
                    </MenuButton>
                    <MenuButton
                        onClick={() => {
                            setTimeFormat('h:mma')
                            bs().setCurrentItin(bs().selectedItinID)
                        }}
                        style={{
                            background: ColoursObj.backgrounds.secondary,
                        }}
                    >
                        <Stack direction={'row'} gap={'16px'}>
                            <Radio
                                style={{ padding: '0px' }}
                                sx={{
                                    color: ColoursObj.font.primary,
                                }}
                                checked={timeFormat === 'h:mma'}
                            />
                            <Typography>
                                {new EventrDate(
                                    '04:20'
                                ).userLocalLuxon.toFormat('h:mma') +
                                    ' ' +
                                    new EventrDate(
                                        '16:20'
                                    ).userLocalLuxon.toFormat('h:mma') +
                                    ' ( 12 ' +
                                    i18n.t('general.hour') +
                                    ' )'}
                            </Typography>
                        </Stack>
                    </MenuButton>
                </Stack>
            </Gutters>
        </NavigationView>
    )
}
